import { IAppState } from '../../../AppModulesWrapper';

import { TAnalyticsOfferStatus } from '../../types/analytics';
import { selectIsNewOffer } from '../offer';

export const selectAnalyticsOfferStatus = (state: IAppState): TAnalyticsOfferStatus => {
  const isNewOffer = selectIsNewOffer(state);

  return isNewOffer ? 'New_ad' : 'Edit_ad';
};
